<template>
  <b-overlay :show="isLoading">
    <b-row>
      <b-col cols="12">
        <b-card>
          <h1 class="mb-3">ایجاد یک آزمون جدید برای جلسه</h1>
          <exam-creation
            v-if="!scheduleDetails.examId"
            ref="examCreation"
            @getExamQuestions="setExamQuestions"
          ></exam-creation>
          <div v-else class="d-flex align-items-center justify-content-center">
            <p class="text-center">شما قبلا برای این جلسه آزمون ساخته‌اید!</p>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </b-overlay>
</template>
<script>
export default {
  emits: ["updateSchedule"],
  props: {
    scheduleDetails: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isLoading: false,
      examDetails: {
        isDeleted: false,
        parentId: null,
        examId: 0,
        masterUserId: 0,
        studentUserId: 0,
        lessonId: null,
        courseId: null,
        result: null,
        masterResult: null,
        systemResult: null,
        status: 1,
        createDate: null,
        sessionStartTime: null,
        sessionEndTime: null,
        examQuestions: [],
      },
    };
  },
  methods: {
    setExamQuestions(examQuestions) {
      if (this.scheduleDetails.parentExamId) {
        this.examDetails.parentId = this.scheduleDetails.parentExamId;
      }
      this.examDetails.masterUserId = this.scheduleDetails.masterUserId;
      this.examDetails.studentUserId = this.scheduleDetails.studentUserId;
      this.examDetails.lessonId = this.scheduleDetails.lessonId;
      this.examDetails.createDate = new Date(Date.now());
      this.examDetails.sessionStartTime = new Date(
        `${this.scheduleDetails.startDate}`
      );
      this.examDetails.sessionEndTime = new Date(
        `${this.scheduleDetails.endDate}`
      );
      this.examDetails.courseId = this.scheduleDetails.courseId;
      this.examDetails.examQuestions = examQuestions;
      this.createAnExam();
    },
    async createAnExam() {
      try {
        this.isLoading = true;
        let _this = this;
        let createAnExam = new CreateAnExam(_this);
        createAnExam.setRequestParamDataObj(_this.examDetails);
        await createAnExam.fetch((response) => {
          if (response.isSuccess) {
            _this.updateSchedule(response.data.exam.examId);
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "آزمون با موفقیت ایجاد شد",
                icon: "ClipboardIcon",
                variant: "success",
              },
            });
            _this.examDetails = {
              isDeleted: false,
              parentId: null,
              examId: 0,
              masterUserId: 0,
              studentUserId: 0,
              lessonId: null,
              courseId: null,
              result: null,
              masterResult: null,
              systemResult: null,
              status: 1,
              createDate: null,
              sessionStartTime: null,
              sessionEndTime: null,
              examQuestions: [],
            };
            _this.$refs.examCreation.resetQuestions();
            _this.$router.push(`/master/reserved/${_this.$route.params.id}/`);
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    async updateSchedule(examId) {
      try {
        this.isLoading = true;
        let scheduleClone = JSON.parse(JSON.stringify(this.scheduleDetails));
        scheduleClone.examId = examId;
        let _this = this;
        let updateAScheduleForMaster = new UpdateAScheduleForMaster(_this);
        updateAScheduleForMaster.setRequestParamDataObj(scheduleClone);
        await updateAScheduleForMaster.fetch((response) => {
          if (response.isSuccess) {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "جلسه با موفقیت ویرایش شد",
                icon: "ClipboardIcon",
                variant: "success",
              },
            });
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
  components: {
    BCard,
    BRow,
    BCol,
    BFormFile,
    BForm,
    BFormGroup,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BOverlay,
    ExamCreation,
  },
};
import {
  BCard,
  BRow,
  BCol,
  BFormFile,
  BForm,
  BFormGroup,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BOverlay,
} from "bootstrap-vue";
import { CreateAnExam } from "@/libs/Api/Exam";
import { UpdateAScheduleForMaster } from "@/libs/Api/Schedules";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import ExamCreation from "@/views/components/Exams/ExamCreation.vue";
</script>
